"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _Button = _interopRequireDefault(require("@mui/material/Button"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Menu = _interopRequireDefault(require("@mui/icons-material/Menu"));

var _ChevronRight = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));

var _Reorder = _interopRequireDefault(require("@mui/icons-material/Reorder"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));

var _Divider = _interopRequireDefault(require("@mui/material/Divider"));

var _List = _interopRequireDefault(require("@mui/material/List"));

var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));

var _react2 = require("@emotion/react");

var _styles = require("@mui/material/styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DesktopDiv = (0, _styles.styled)('div')(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    display: 'none'
  }, _ref2[theme.breakpoints.up('md')] = {
    display: 'flex'
  }, _ref2;
});
var MobileDiv = (0, _styles.styled)('div')(function (_ref3) {
  var _ref4;

  var theme = _ref3.theme;
  return _ref4 = {
    display: 'flex'
  }, _ref4[theme.breakpoints.up('md')] = {
    display: 'none'
  }, _ref4;
});

var ResponsiveMenu = function ResponsiveMenu(_ref5) {
  var scroll = _ref5.scroll,
      _ref5$sections = _ref5.sections,
      sections = _ref5$sections === void 0 ? [] : _ref5$sections,
      handleMenuClose = _ref5.handleMenuClose,
      statemobileMoreAnchorEl = _ref5.statemobileMoreAnchorEl,
      transparent = _ref5.transparent,
      _ref5$contrastColor = _ref5.contrastColor,
      contrastColor = _ref5$contrastColor === void 0 ? 'white' : _ref5$contrastColor;

  var _useState = (0, _react.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var theme = (0, _react2.useTheme)();

  var handleOpen = function handleOpen(e) {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(DesktopDiv, {
    style: {
      color: transparent ? contrastColor : undefined
    }
  }, sections.map(function (_ref6, i) {
    var onClick = _ref6.onClick,
        name = _ref6.name,
        _ref6$isDivider = _ref6.isDivider,
        isDivider = _ref6$isDivider === void 0 ? false : _ref6$isDivider;

    if (isDivider) {
      return /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
        key: "divider" + i,
        orientation: "vertical",
        flexItem: true,
        style: {
          margin: 5,
          backgroundColor: transparent ? contrastColor : null
        }
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      key: "button_" + name,
      style: {
        margin: 8
      },
      onClick: onClick,
      "aria-label": name,
      color: "inherit"
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "h6"
    }, name));
  })), /*#__PURE__*/_react["default"].createElement(MobileDiv, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "show more",
    "aria-haspopup": "true",
    onClick: handleOpen,
    color: "inherit"
  }, /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    style: {
      color: transparent ? contrastColor : undefined
    }
  }))), /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    anchor: "right",
    open: isOpen,
    onClose: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], null, /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    button: true,
    key: '0',
    onClick: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null))), /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), sections.map(function (_ref7, i) {
    var _ref7$name = _ref7.name,
        name = _ref7$name === void 0 ? '' : _ref7$name,
        _onClick = _ref7.onClick,
        icon = _ref7.icon,
        _ref7$isDivider = _ref7.isDivider,
        isDivider = _ref7$isDivider === void 0 ? false : _ref7$isDivider;

    if (isDivider) {
      return /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
        key: "divider_" + i
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      button: true,
      key: name,
      onClick: function onClick() {
        handleClose();
        setTimeout(_onClick, 1);
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, icon || /*#__PURE__*/_react["default"].createElement(_Reorder["default"], null)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: name
    }));
  }))));
};

var _default = ResponsiveMenu;
exports["default"] = _default;
module.exports = exports.default;